const GROUP_LABEL_PREFIX = 'Groupe';
const NUMBERED_GROUP_LABEL = new RegExp(`^${GROUP_LABEL_PREFIX} (\\d+)$`);

export const suggestGroupLabel = (
  existingLabels: readonly (string | null | undefined)[],
): string => {
  const usedNumbers = new Set(
    existingLabels
      .map((label) => NUMBERED_GROUP_LABEL.exec(label?.trim() ?? '')?.[1])
      .filter((digits): digits is string => !!digits)
      .map(Number),
  );

  let candidate = 1;

  while (usedNumbers.has(candidate)) {
    candidate += 1;
  }

  return `${GROUP_LABEL_PREFIX} ${candidate.toString()}`;
};
